import { render, staticRenderFns } from "./AdvanceInList.vue?vue&type=template&id=20974a96&scoped=true"
import script from "./AdvanceInList.vue?vue&type=script&lang=js"
export * from "./AdvanceInList.vue?vue&type=script&lang=js"
import style0 from "./AdvanceInList.vue?vue&type=style&index=0&id=20974a96&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20974a96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20974a96')) {
      api.createRecord('20974a96', component.options)
    } else {
      api.reload('20974a96', component.options)
    }
    module.hot.accept("./AdvanceInList.vue?vue&type=template&id=20974a96&scoped=true", function () {
      api.rerender('20974a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/AdvanceInList.vue"
export default component.exports